export const events = {
  USER_SIGNED_IN: 'auth/user_signed_in',
  USER_SIGNED_OUT: 'auth/user_signed_out',
  STRIPE_CUSTOMER_CREATED: 'auth/stripe_customer_created',
  STRIPE_CUSTOMER_FOUND: 'auth/stripe_customer_found',
};